/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { UserProfile } from "./user-profile";

const HeaderLoginBase = (props) => {
  const {
    openLoginTemplate,
    closeLoginTemplate,
    headerTheme,
    enableSSO,
    localizedElementsData = {},
    member,
    sso = {},
  } = props;
  const { signInSignUp = {} } = localizedElementsData;
  const { signIn: localizedSignIn } = signInSignUp;
  const headerType = headerTheme.includes("single-layer") ? "single-layer" : "";

  useEffect(() => {
    if (enableSSO && !member) updateMember();
  }, [member]);

  const updateMember = async () => {
    const { currentUser } = await import("@quintype/bridgekeeper-js");
    try {
      const { user } = await currentUser();
      if (user && user["verification-status"]) {
        props.updateMember(user);
      }
    } catch (err) {
      console.log(err);
    }
  };

  if (!enableSSO) return null;
  return (
    <UserProfile
      openLoginTemplate={openLoginTemplate}
      closeLoginTemplate={closeLoginTemplate}
      member={member}
      customCssClasses={headerType}
      localizedSignIn={localizedSignIn}
      sso={sso}
    />
  );
};

HeaderLoginBase.propTypes = {
  openLoginTemplate: PropTypes.bool,
  closeLoginTemplate: PropTypes.bool,
  headerTheme: PropTypes.string,
  enableSSO: PropTypes.bool,
  localizedElementsData: PropTypes.shape({
    buttonLabels: PropTypes.shape({
      signIn: PropTypes.string,
    }),
  }),
  updateMember: PropTypes.func,
  member: PropTypes.object,
  sso: PropTypes.object,
};

const mapStateToProps = (state) => {
  const { enableLocalization = false, localizedElements = {} } = get(
    state.qt,
    ["config", "pagebuilder-config", "general", "localization"],
    {}
  );
  return {
    headerTheme: get(state.qt, ["config", "pagebuilder-config", "header", "headerStyle"], "header_1"),
    enableSSO: get(state.qt, ["config", "pagebuilder-config", "header", "enableSSO"], false),
    localizedElementsData: enableLocalization ? localizedElements : {},
    sso: get(state.qt, ["config", "pagebuilder-config", "general", "sso"], {}),
    member: get(state, ["member"], null),
  };
};

const mapDispatchToProps = (dispatch) => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" }),
  closeLoginTemplate: () => dispatch({ type: "CLOSE_LOGIN_TEMPLATE" }),
  updateMember: (member) => dispatch({ type: "MEMBER_UPDATED", member }),
});

export const HeaderLogin = connect(mapStateToProps, mapDispatchToProps)(HeaderLoginBase);

export { HeaderLoginBase };
